import { Banner } from 'component/banner'
import QueueAnim from 'rc-queue-anim';
import ScrollElement from 'rc-scroll-anim/lib/ScrollElement';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';

import sizeImg from 'image/size.png'
import './product.less'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { PlayCircleOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useEffect, useState } from 'react';
import { post } from 'request/request';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectLocale } from 'store/localeSlice';
import { FullScreenModal } from 'component/modal';

export const Product = () => {
    const [isModalVisible, setModalVisible] = useState(false)
    const [loopModalVisible, setLoopModalVisible] = useState(false)
    const intl = useIntl();
    const locale= useSelector(selectLocale);

    const [curVideo, setCurVideo] = useState('')
    const [loopList, setLoopList] = useState([])
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    const isMobile = navigator.userAgent.match(/(Mobi|Android|iPhone)/i);
    const videoUrl = locale === 'ko' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/16814373436434676.mp4' : 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16710739680436841.mp4';

    const gifBanner = [
        {
            title: intl.formatMessage({id: 'product.gifBanner.title1'}),
            content: intl.formatMessage({id: 'product.gifBanner.con1'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702234598284774.png'
        },
        {
            title: intl.formatMessage({id: 'product.gifBanner.title2'}),
            content: intl.formatMessage({id: 'product.gifBanner.con2'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702235271111554.gif'
        },
        {
            title: intl.formatMessage({id: 'product.gifBanner.title3'}),
            content: intl.formatMessage({id: 'product.gifBanner.con3'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702235773343426.gif'
        },
        {
            title: intl.formatMessage({id: 'product.gifBanner.title4'}),
            content: intl.formatMessage({id: 'product.gifBanner.con4'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702235455168312.gif'
        },
        {
            title: intl.formatMessage({id: 'product.gifBanner.title5'}),
            content: intl.formatMessage({id: 'product.gifBanner.con5'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702236273532428.png'
        }
    ]
    const imgBanner = [
    {
        title: intl.formatMessage({id: 'product.imgBanner.title1'}),
        content: intl.formatMessage({id: 'product.imgBanner.con1'}),
        url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702905822393545.png'
    },
    {
        title: intl.formatMessage({id: 'product.imgBanner.title2'}),
        content: intl.formatMessage({id: 'product.imgBanner.con2'}),
        url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16703076027764426.png'
        // url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702919874547293.png'
    },
    {
        title: intl.formatMessage({id: 'product.imgBanner.title3'}),
        content: intl.formatMessage({id: 'product.imgBanner.con3'}),
        url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702906761959864.png'
    },
    {
        title: intl.formatMessage({id: 'product.imgBanner.title4'}),
        content: intl.formatMessage({id: 'product.imgBanner.con4'}),
        url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702906962702322.png'
    },
    {
        title: intl.formatMessage({id: 'product.imgBanner.title5'}),
        content: intl.formatMessage({id: 'product.imgBanner.con5'}),
        url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16702920318322935.png'
    }
    ]
    const proList = [
        {
            title: intl.formatMessage({id: 'product.proList.title1'}),
            content: intl.formatMessage({id: 'product.proList.con1'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16703114625615144.png'
        },
        {
            title: intl.formatMessage({id: 'product.proList.title2'}),
            content: intl.formatMessage({id: 'product.proList.con2'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16703115271324422.png'
        },
        {
            title: intl.formatMessage({id: 'product.proList.title3'}),
            content: intl.formatMessage({id: 'product.proList.con3'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16703115469285953.png'
        }
        ]
    const proList2 = [
        {
            title: intl.formatMessage({id: 'product.proList2.title1'}),
            content: intl.formatMessage({id: 'product.proList2.con1'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16708946269121843.png'
        },
        {
            title: intl.formatMessage({id: 'product.proList2.title2'}),
            content: intl.formatMessage({id: 'product.proList2.con2'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16708947016715454.png'
        },
        {
            title: intl.formatMessage({id: 'product.proList2.title3'}),
            content: intl.formatMessage({id: 'product.proList2.con3'}),
            url: 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16708947168778849.png'
        }
    ]
    const specificationList = [
        {
            name: intl.formatMessage({id: 'product.specificationList.title1'}),
            con: '(1015/1060)*575*(1041/1220)mm'
        },
        {
            name: intl.formatMessage({id: 'product.specificationList.title2'}),
            con: '120kg'
        },
        {
            name: intl.formatMessage({id: 'product.specificationList.title3'}),
            con: '0-36'
        },
        {
            name: intl.formatMessage({id: 'product.specificationList.title4'}),
            con: '50N.M'
        },
        {
            name: intl.formatMessage({id: 'product.specificationList.title5'}),
            con: 'DC24V 100W'
        },
        {
            name: intl.formatMessage({id: 'product.specificationList.title6'}),
            con: intl.formatMessage({id: 'product.specificationList.con6'})
        },
        {
            name: intl.formatMessage({id: 'product.specificationList.title7'}),
            con: intl.formatMessage({id: 'product.specificationList.con7'})
        }
    ]
    useEffect(() => {
        post('snailcar/website/common/queryReview',{pageNo: 1,pageSize: 999}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setLoopList(data.resultBody.data.list)
            }
        })
    }, [])
    const docWidth = document.documentElement.clientWidth;
    return <div className="product-container">
        <div className="product-banner">
            <img className='pc-block' style={{width: '100%'}} src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycl/course/16752423466954419.png" alt="" />
            <img className='mobile-block' style={{width: '100%'}} src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycl/course/16752424029528551.png" alt="" />
            <div className='product-title'>
                <p>{intl.formatMessage({id: 'product.title'})}</p>
                {/* <p>{intl.formatMessage({id: 'home.price.num'})}</p> */}
            </div>
            <ScrollElement><QueueAnim type={docWidth > 999 ? 'right' : 'left'} delay={300} key="key1">
                <div key="key2"
                    className='paly-btn' onClick={() => isMobile ? (window.location.href = videoUrl) : setModalVisible(true)}>
                    <Space><PlayCircleOutlined /><span>{intl.formatMessage({id: 'product.play.btn'})}</span></Space>
                </div>
            </QueueAnim></ScrollElement>
            
        </div>
        <div className='banner-wrapper'>
            {/* <ScrollOverPack>
                <QueueAnim
                    type={'bottom'}
                    className="banner-title"
                    key="key3"
                    duration={500}
                >  
                    <div key="key4" className='title'>{intl.formatMessage({id: 'product.banner.title1'})}</div>
                    <div key="key5" className='content'>{intl.formatMessage({id: 'product.banner.con1'})}</div>
                </QueueAnim>
            </ScrollOverPack> */}
            <ScrollElement>
                <QueueAnim className="banner-title" type={'bottom'} duration={1000} delay={300} key="key3">
                    <div key="key4" className='title'>{intl.formatMessage({id: 'product.banner.title1'})}</div>
                    <div key="key5" className='content'>{intl.formatMessage({id: 'product.banner.con1'})}</div>
                </QueueAnim>
            </ScrollElement>
            <Banner data={gifBanner} type="1"></Banner>
            <ScrollOverPack playScale={[0.2,0.3]}>
                <QueueAnim
                    duration={500}
                    // type={'bottom'}
                    animConfig={{ opacity:[1, 0], translateY:[0, 25] }}
                    className="banner-title banner-title2"
                    key="key6"
                >  
                    <div key="key7" className='title'>{intl.formatMessage({id: 'product.banner.title2'})}</div>
                    <div key="key8" className='content'>{intl.formatMessage({id: 'product.banner.con2'})}</div>
                </QueueAnim>
            </ScrollOverPack>
            <Banner data={imgBanner} type="2"></Banner>
            <div className='pro-detail-wrapper'>
                <ScrollOverPack playScale={[0.2,0.3]}>
                    <QueueAnim
                        duration={500}
                        // type={'bottom'}
                        animConfig={{ opacity:[1, 0], translateY:[0, 25] }}
                        className="banner-title banner-title2"
                        key="key9"
                    >  
                        <div key="key10">{intl.formatMessage({id: 'product.Exclusive.Features'})}</div>
                    </QueueAnim>
                </ScrollOverPack>
                {/* <div className='banner-title banner-title2' >{intl.formatMessage({id: 'product.Exclusive.Features'})}</div> */}
                <div className='pro-list'>
                    {proList.map((item,index) => <div key={'pro'+index} className='pro-item'>
                        {index%2===0 && <img className='middle-block' src={item.url} alt="" />}
                        <img className='middle-block-none' src={item.url} alt="" />
                        {/* <div className='con-wrapper'>
                            <ScrollOverPack playScale={[0.2,0.3]}>
                                <QueueAnim
                                    key="key11" className='title'
                                    // type="bottom"
                                    animConfig={{ opacity:[1, 0], translateY:[0, 100] }}
                                    duration={1000}
                                    >
                                    {item.title}
                                </QueueAnim>
                                <QueueAnim
                                    key="key12" className='content'
                                    // type="bottom"
                                    duration={1000}
                                    animConfig={{ opacity:[1, 0], translateY:[0, 100] }}
                                    delay={1000}
                                    >
                                    {item.content}
                                </QueueAnim>
                            </ScrollOverPack>
                        </div> */}
                        <ScrollOverPack className='con-wrapper' playScale={[0.2,0.3]}>
                            <QueueAnim
                                key="key11"
                                leaveReverse
                                // type="bottom"
                                animConfig={{ opacity:[1, 0], translateY:[0, 25] }}
                                duration={500}
                                >
                                <div key="key-title" className='title'>{item.title}</div>
                                <div key="key-con" className='content'>{item.content}</div>
                            </QueueAnim>
                        </ScrollOverPack>

                        {/* <div className='con-wrapper'>
                            <div>
                                <div className='title'>{item.title}</div>
                                <div className='content'>{item.content}</div>
                            </div>
                        </div> */}
                        {index%2!==0 && <img className='middle-block' src={item.url} alt="" />}
                    </div>)}
                </div>
            </div>
        </div>
        <div className='pro-list2'>
            {proList2.map((item,index:number) => <div key={'pro2'+index} className='pro-item'>
                {index%2===0 && <div className='img-wrapper middle-block-none'><img src={item.url} alt="" /></div>}
                <div className='img-wrapper middle-block'><img src={item.url} alt="" /></div>
                {/* <div className='con-wrapper'>
                    <div>
                        <div className='title'>{item.title}</div>
                        <div className='content'>{item.content}</div>
                    </div>
                </div> */}
                {/* <div className='con-wrapper'>
                    <ScrollOverPack  playScale={[0.2,0.3]}>
                        <QueueAnim
                            key="1" className='title'
                            leaveReverse
                            type="bottom"
                            >
                            {item.title}
                        </QueueAnim>
                        <QueueAnim
                            key="2" className='content'
                            leaveReverse
                            type="bottom"
                            >
                            {item.content}
                        </QueueAnim>
                    </ScrollOverPack>
                </div> */}
                <ScrollOverPack className='con-wrapper'  playScale={[0.2,0.3]}>
                    <QueueAnim
                        key="key-text"
                        leaveReverse
                        // type="bottom"
                        animConfig={{ opacity:[1, 0], translateY:[0, 25] }}
                        duration={500}
                        >
                        <div key="key14" className='title'>{item.title}</div>
                        <div key="key15" className='content'>{item.content}</div>
                    </QueueAnim>
                </ScrollOverPack>
                {index%2!==0 && <div className='img-wrapper middle-block-none'><img src={item.url} alt="" /></div>}
            </div>)}
        </div>
        <div className='banner-wrapper'>
            <div className='product-banner2'>
                <img src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16703140589018394.png" alt="" />
                <div className='banner-con'>{intl.formatMessage({id: 'product.banner.title3'})}</div>
            </div>
            <div>
                <ScrollOverPack  playScale={[0.2,0.3]}>
                    <QueueAnim
                        // type={'bottom'}
                        className="banner-title spec-title"
                        key="key16"
                        animConfig={{ opacity:[1, 0], translateY:[0, 25] }}
                        duration={500}
                    >  
                        <div key="key17">{intl.formatMessage({id: 'product.banner.con3'})}</div>
                    </QueueAnim>
                </ScrollOverPack>
                {/* <div className='banner-title spec-title'>{intl.formatMessage({id: 'product.banner.con3'})}</div> */}
                <div className='specification-wrapper'>
                    <div className='spec-right-img mobile-block'>
                        <img src={sizeImg} alt="" />
                    </div>
                    <ul className='spec-ul'>
                        {specificationList.map((item,index) => <li key={'spec'+index} className='spec-li'>
                            <span className='name'>{item.name}</span>
                            <span className='com'>{item.con}</span>
                        </li>)}
                    </ul>
                    <div className='spec-right-img pc-block'>
                        <img src={sizeImg} alt="" />
                    </div>
                </div>
            </div>
            <ScrollOverPack  playScale={[0.2,0.3]}>
                <QueueAnim
                    // type={'bottom'}
                    className="banner-title loop-title"
                    key="key18"
                    animConfig={{ opacity:[1, 0], translateY:[0, 25] }}
                    duration={500}
                >  
                    <div key="key19">{intl.formatMessage({id: 'product.customerReviews'})}</div>
                </QueueAnim>
            </ScrollOverPack>
            {/* <div className='banner-title loop-title'>{intl.formatMessage({id: 'product.customerReviews'})}</div> */}
            <div className='middle-block-none'>
                <Slider {...settings}>
                    {
                        loopList.map((item:any,index) => <div key={'loop'+ index}>
                            <div className='loopList-item'>
                                <div className='img-div' onClick={() => {
                                    setCurVideo(item.video);
                                    isMobile ? (window.location.href = item.video) : setLoopModalVisible(true);
                                    }}><img src={item.image} alt="" /><PlayCircleOutlined className='icon'/></div>
                                <div style={{flex: 1}}>
                                    <div className='title'>{item.name}</div>
                                    {/* <div className='time'>{item.time}</div> */}
                                    <div className='con'>{item.des}</div>
                                </div>
                            </div>
                        </div>)
                    }
                </Slider>
            </div>
        </div>
        <div className='pro-list2 middle-block' style={{marginTop: 40}}>
            {loopList.map((item:any,index:number) => <div key={'loop-middle'+index} className='pro-item'>
                <div className='img-div'  onClick={() =>  {setCurVideo(item.video);setLoopModalVisible(true)}}><img src={item.image} alt="" /><PlayCircleOutlined className='icon'/></div>
                <div className='con-wrapper'>
                    <div>
                        <div className='title'>{item.name}</div>
                        <div className='content'>{item.des}</div>
                    </div>
                </div>
            </div>)}
        </div>
        {/* <ConfigProvider
        //   theme={{
        //     token: {
        //       colorPrimary: '#F6D3CE',
        //     },
        //   }}
        >
           {isModalVisible&&<Modal title="" open={isModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setModalVisible(false)}}>
		   <video webkit-playsinline="true" playsInline autoPlay style={{width: '100%',marginTop: 30}} controls={true} src={locale === 'ko' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/16814373436434676.mp4' : 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16710739680436841.mp4'} ></video>
          </Modal>}
          {loopModalVisible&&<Modal title="" open={loopModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setLoopModalVisible(false)}}>
		   <video style={{width: '100%',marginTop: 30}} webkit-playsinline="true" autoPlay playsInline controls={true} src={curVideo} ></video>
          </Modal>}
        </ConfigProvider> */}
        <FullScreenModal setOpen={setModalVisible} open={isModalVisible} url={videoUrl} />
        <FullScreenModal setOpen={setLoopModalVisible} open={loopModalVisible} url={curVideo} />
    </div>
}